import { graphql } from "@server/gql";

export const fragments = graphql(/* GraphQL */ `
  fragment rootLayoutEntry on Entry {
    __typename
    sys {
      id
    }
  }

  fragment rootLayoutSiteinfo on Siteinfo {
    ...rootLayoutEntry
    title
    description
    faviconCollection(limit: 1) {
      total
      items {
        url
      }
    }
    openGraphImage {
      url
    }
    copyright {
      json
    }
    newsletter {
      ...rootLayoutEntry
      name
      reference
    }
    sideMenuServicePages {
      ...rootLayoutEntry
    }
    sideMenuMyPages {
      ...rootLayoutEntry
    }
    myPagesStartPage {
      ...rootLayoutEntry
      slug
    }
    myPagesRegisterPage {
      ...rootLayoutEntry
      slug
    }
    campaignPriorityCollection(limit: 50) {
      items {
        ... on Campaign {
          __typename
          sys {
            id
          }
        }
      }
    }
    minimumOrderValue
    showCheckoutMadeToOrderDisclaimer
  }

  fragment rootLayoutWishlist on Page {
    slug
  }

  fragment rootLayoutCampaign on Campaign {
    __typename
    sys {
      id
    }
    campaignTitle
    campaignBadge
    campaignLabel
    commerceId
    elevateReferenceId
    norceReferenceId
    slug
    campaignStart
    campaignEnd
    showBadgeForAllProductsInCampaign
  }
`);

export default graphql(/* GraphQL */ `
  query RootLayout($locale: String!, $country: String!) {
    siteinfoCollection(limit: 1, locale: $locale) {
      items {
        ...rootLayoutSiteinfo
      }
    }
    wishlist: pageCollection(
      limit: 1
      locale: $locale
      where: { type: "Wishlist" }
    ) {
      items {
        ...rootLayoutWishlist
      }
    }
    campaigns: campaignCollection(
      limit: 100
      locale: $locale
      where: { activeMarkets_contains_some: [$country] }
    ) {
      items {
        ...rootLayoutCampaign
      }
    }
  }
`);
